import { Controller } from "stimulus";
import * as basicLightbox from "basiclightbox";

export default class extends Controller {
  connect() {
    this.modal = basicLightbox.create(this.element.querySelector("#watch-template"));

    if (location.hash && location.hash === `#${this.element.id}`) {
      this.show();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }
  }

  disconnect() {
    delete this.modal;
  }

  show(event) {
    if (event) event.preventDefault();
    this.modal.show();
  }
}
